import { TLoggerParameters } from './Logger.types';
import { LoggerLevel, LoggerSource } from './LoggerLevel';

export function getConsoleLabel(level: LoggerLevel, parameters?: TLoggerParameters) {
    let label = '';
    switch (parameters?.source) {
        case LoggerSource.Game:
            label = `%c[${LoggerSource[parameters.source]}] / `;
            break;
        case LoggerSource.React:
            label = `%c[${LoggerSource[parameters.source]}] / `;
            break;
        default:
            label = '%c';
            break;
    }

    switch (level) {
        case LoggerLevel.Constructor:
            label += `%c${LoggerLevel[level]} / %c${parameters?.class} %c`;
            break;
        case LoggerLevel.UseEffect:
            label += `%c${LoggerLevel[level]} / %c${parameters?.component} %c`;
            break;
        case LoggerLevel.Message:
            label += `%c${LoggerLevel[level]} / %c${parameters?.component} / %c${parameters?.fn} `;
            break;
        case LoggerLevel.Error:
            label += `[ERROR] %c${LoggerLevel[level]} / %c${parameters?.class} / %c${parameters?.fn} / ${parameters?.message} `;
            break;
        default:
            label += `%c${LoggerLevel[level]} / %c${parameters?.message} %c`;
            break;
    }

    return label;
}

export function getConsoleColors(level: LoggerLevel) {
    let color0: string, color1: string, color2: string, color3: string;

    switch (level) {
        case LoggerLevel.UseEffect:
            color0 = 'color:#b80789';
            color1 = 'color:#f0fc03';
            color2 = 'color:#78B874';
            color3 = 'color:#D6E9D5';
            break;
        case LoggerLevel.Error:
            color0 = 'color:#b8070a';
            color1 = 'color:#cf1518';
            color2 = 'color:#cf3032';
            color3 = 'color:#d94143';
            break;
        default:
            color0 = 'color:#b80789';
            color1 = 'color:#3CBAF9';
            color2 = 'color:#78B874';
            color3 = 'color:#D6E9D5';
            break;
    }

    return {
        c0: color0,
        c1: color1,
        c2: color2,
        c3: color3
    };
}
